module.exports = __webpack_public_path__ + "img/logo-sm-light.bfa9aef0.png";